import { render, staticRenderFns } from "./HotKeyword.vue?vue&type=template&id=53442a72&scoped=true&"
import script from "./HotKeyword.vue?vue&type=script&lang=js&"
export * from "./HotKeyword.vue?vue&type=script&lang=js&"
import style0 from "./HotKeyword.vue?vue&type=style&index=0&id=53442a72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53442a72",
  null
  
)

export default component.exports